<template>

    <oa-modal :name="name" @before-open="beforeOpen" >

        <template slot="description">{{ question }}</template>

        <template slot="footer">
            <div>
            <button class="btn btn-green" @click="confirmClicked">
                Yes
            </button>
            <button class="btn btn-small white-bg ut-ml-4" @click="cancelClicked">
                No
            </button>
            </div>
        </template>

    </oa-modal>

</template>

<script>
import OaModal from '@/components/Modals/OaModal.vue';

export default {
  name: 'ConfirmModal',
  components: { OaModal },
  data() {
    return {
      name: 'confirm-modal',
      question: 'Do you wish to continue?',
      onconfirm: null,
      oncancel: null,
    };
  },
  methods: {
    beforeOpen(event) {
      if (!!event && !!event.params) {
        if (event.params.question) {
          this.question = event.params.question;
        }
        if (event.params.onconfirm) {
          this.onconfirm = event.params.onconfirm;
        }
        if (event.params.oncancel) {
          this.oncancel = event.params.oncancel;
        }
      }
    },
    setQuestion(question) {
      this.question = question;
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
    confirmClicked() {
      if (this.onconfirm && {}.toString.call(this.onconfirm) === '[object Function]') {
        this.onconfirm();
      }
      this.closeModal();
    },
    cancelClicked() {
      if (this.oncancel && {}.toString.call(this.oncancel) === '[object Function]') {
        this.oncancel();
      }
      this.closeModal();
    },
  },
};
</script>

<style scoped>

</style>
